import MKBox from "components/MKBox";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import "devextreme/dist/css/dx.light.css";
import MKTypography from "components/MKTypography";
import requests from "API/propertiesRequests";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Gallery from "../sections/Gallery";
import Map from "../sections/Maps";
import Details from "../sections/Details";
import PropertyDetails from "../sections/PropertyDetails";
import DownloadFiles from "../sections/DownloadFiles";
import Breadcrumbs from "../../../components/Breadcrumbs";

function CardDetail({ id }) {
  const [property, setProperty] = useState([]);

  useEffect(() => {
    fetch(requests.getByID({ id })).then(async (response) => {
      if (response.ok) {
        setProperty(await response.json());
      }
    });
  }, []);

  return (
    <>
      <MKBox component="section" bgColor="white" py={6}>
        <Container>
          <Grid container spacing={1} item xs={12} lg={12} mx="auto">
            <Grid item xs={4}>
              <Breadcrumbs
                routes={[
                  { label: "Inicio", route: "/" },
                  { label: "Búsqueda", route: "/search" },
                  { label: "Detalle de propiedades", route: "#" },
                ]}
              />
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <MKBox minHeight="15vh" width="100%">
        <Container>
          <MKBox
            color="black"
            variant="gradient"
            p={3}
            position="relative"
            sx={{
              backgroundColor: "#FFF",
              display: "grid",
              placeItems: "right",
              backgroundSize: "cover",
            }}
          >
            <MKTypography variant="h1" textGradient color="secondary">
              {property.name}
            </MKTypography>
          </MKBox>
          <MKBox
            py={1}
            width="100%"
            position="relative"
            sx={{
              display: "grid",
              placeItems: "Justify",
              backgroundSize: "cover",
            }}
          >
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={10} lg={9} position="relative" pc={0}>
                  <Tabs>
                    <TabList>
                      <Tab>
                        <MKTypography variant="body2" color="text" pl={1}>
                          <span className="material-icons-outlined">photo_camera</span>
                          <br />
                          FOTOS
                        </MKTypography>
                      </Tab>
                      <Tab>
                        <MKTypography variant="body2" color="text" pl={1}>
                          <span className="material-icons-outlined">pin_drop</span>
                          <br />
                          UBICACION
                        </MKTypography>
                      </Tab>
                      <Tab>
                        <MKTypography variant="body2" color="text" pl={1}>
                          <span className="material-icons-outlined">picture_as_pdf</span>
                          <br />
                          DESCARGAR
                        </MKTypography>
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <Gallery imageProperty={property?.imagesproperty_set} />
                    </TabPanel>
                    <TabPanel>
                      <Map property={property} />
                    </TabPanel>
                    <TabPanel>
                      <DownloadFiles property={property} />
                    </TabPanel>
                  </Tabs>
                </Grid>
                <Grid
                  item
                  xs={8}
                  lg={3}
                  sx={{
                    backgroundColor: "#FFF",
                    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                    height: "610px",
                  }}
                >
                  <Details property={property} />
                </Grid>
              </Grid>
            </Container>
          </MKBox>
        </Container>
        <Container>
          <Grid container spacing={2}>
            <Grid
              container
              item
              xs={12}
              lg={9}
              justifyContent="left"
              alignItems="left"
              sx={{ mx: "auto", textAlign: "left" }}
              pc={1}
            >
              <div className="stats">
                <div>
                  <div className="sub-title">
                    <MKTypography variant="button" color="text">
                      <span className="material-icons-outlined">select_all</span>
                      <b>
                        &nbsp;{property.area}
                        <sup>2</sup>
                      </b>
                    </MKTypography>
                  </div>
                  <MKTypography variant="body2">Área</MKTypography>
                </div>
                <div>
                  <div className="sub-title">
                    <MKTypography variant="button" color="text">
                      <span className="material-icons-outlined">bed</span>
                      <b>&nbsp;{property.rooms}</b>
                    </MKTypography>
                  </div>
                  <MKTypography variant="body2">Habitaciones</MKTypography>
                </div>
                <div>
                  <MKTypography variant="button" color="text">
                    <span className="material-icons-outlined">shower</span>
                    <b>&nbsp;{property.restrooms}</b>
                  </MKTypography>
                  <MKTypography variant="body2">Baños</MKTypography>
                </div>
                <div>
                  <MKTypography variant="button" color="text">
                    <span className="material-icons-outlined">directions_car</span>
                    <b>&nbsp;{property.parkings}</b>
                  </MKTypography>
                  <MKTypography variant="body2">Parqueo</MKTypography>
                </div>
                <div>
                  <MKTypography variant="button" color="text">
                    <span className="material-icons-outlined">maps_home_work</span>
                    <b>&nbsp;{property.levels}</b>
                  </MKTypography>
                  <MKTypography variant="body2">Niveles</MKTypography>
                </div>
              </div>
            </Grid>
            <Grid item xs={8} lg={3} />
          </Grid>
        </Container>
      </MKBox>
      <MKBox minHeight="15vh" width="100%">
        <PropertyDetails property={property} />
      </MKBox>
    </>
  );
}

CardDetail.propTypes = {
  id: PropTypes.number.isRequired,
};

export default CardDetail;
